import _ from 'lodash'
import constants from 'scoreboard/components/constants'
import i18n from 'scoreboard/components/i18n'
import $ from 'jquery'

export const AGGREGATIONTYPE_NONE = 'none'
export const HEADER_TYPE_BREAKDOWN_ROW = 'breakdown'
export const HEADER_TYPE_FIELD_ROW = 'field'
export const MAX_RESULTS = 10000
export const MAX_RESULTS_ADMIN = 100000
export const MAX_RECORD_SHOWING_EDIT = 3
export const SOURCE_CALCULATED = 'calculated'
export const SOURCE_BASIC = 'basic'
export const CALCULATED_FIELD_ID_PREFIX = 'calc'
export const COLOR_TYPE_ID_SCORING = 'scoring'
export const COLOR_TYPE_ID_CONDITIONAL = 'conditional'
export const COLOR_TYPE_ID_OVERALL = 'overall'
export const EDIT_FETCH_OPTIONS = {
	limit: constants.REPORT_PREVIEW_LIMIT,
	showCount: true,
	showTotal: true,
	stream: false,
	queryAllColumns: true,

	// #54971 when editing a report, scrolling does not stream more data.
	// the most items that could be present when editing a report are 64 on
	// a double grouped report (i.e. four outer groups of 4 inner groups of
	// 4 items). get all the data in a single chunk
	chunkSize: constants.REPORT_PREVIEW_LIMIT ** 3
}
export const DEFAULT_SORT_PROPERTY = 'defaultSortIndex'
export const SUM_OF_ALL_ID = -1
export const INDENTATION_PIXELS = 10
export const BREAKDOWN_LABEL_LIMIT = 1000
export const REPEAT_BY_TOP_POSITION = 'top'
export const REPEAT_BY_MIDDLE_POSITION = 'middle'
export const REPEAT_BY_BOTTOM_POSITION = 'bottom'
export const REPORT_COLUMN_NOTES_COLUMN_TYPE_ID = 'notes'
export const REPORT_COLUMN_EXPENDITURES_COLUMN_TYPE_ID = 'expenditures'
export const NOTE_DISPLAY_TYPE_ALL = 'all'
export const NOTE_DISPLAY_TYPE_PERIOD_SPECIFIC_ONLY = 'period-specific-only'
export const NOTE_DISPLAY_TYPE_GENERAL_ONLY = 'general-only'
export const NOTE_DISPLAY_PROP_CREATED_DATE = 'createdDate'
export const NOTE_DISPLAY_PROP_APPLIES_TO = 'appliesTo'
export const NOTE_DISPLAY_PROP_DOMAIN_LABEL = 'domainLabel'
export const NOTE_DISPLAY_PROP_REPLIES = 'replies'
export const NOTE_DISPLAY_PROP_AUTHOR = 'author'
export const NOTE_DISPLAY_PROP_DESCENDANTS = 'descendants'

export const REPEAT_BY_CAT_OR_RANGE_RESTRICTION_NONE = 'none'
export const REPEAT_BY_CAT_OR_RANGE_RESTRICTION_DEFAULT = 'default'
export const REPEAT_BY_CAT_OR_RANGE_RESTRICTION_CUSTOM = 'custom'

export const DEFAULT_GROUP_INDEX_KEY = '0.000000'
export const DATASET_REPORT_TYPE = 'dataset'
export const TODAYS_PSEUDO_PERIOD_ID = -1
export const DEFAULT_LABEL_ELLIPSIS_THRESHOLD = 20
export const ELLIPSIS = '\u2026'

const reportConstants = {
	AGGREGATIONTYPE_NONE,
	HEADER_TYPE_BREAKDOWN_ROW,
	HEADER_TYPE_FIELD_ROW,
	MAX_RESULTS,
	MAX_RESULTS_ADMIN,
	MAX_RECORD_SHOWING_EDIT,
	SOURCE_CALCULATED,
	SOURCE_BASIC,
	CALCULATED_FIELD_ID_PREFIX,
	COLOR_TYPE_ID_SCORING,
	COLOR_TYPE_ID_CONDITIONAL,
	COLOR_TYPE_ID_OVERALL,
	EDIT_FETCH_OPTIONS,
	DEFAULT_SORT_PROPERTY,
	SUM_OF_ALL_ID,
	INDENTATION_PIXELS,
	BREAKDOWN_LABEL_LIMIT,
	REPEAT_BY_TOP_POSITION,
	REPEAT_BY_MIDDLE_POSITION,
	REPEAT_BY_BOTTOM_POSITION,
	REPORT_COLUMN_NOTES_COLUMN_TYPE_ID,
	REPORT_COLUMN_EXPENDITURES_COLUMN_TYPE_ID,
	NOTE_DISPLAY_TYPE_ALL,
	NOTE_DISPLAY_TYPE_PERIOD_SPECIFIC_ONLY,
	NOTE_DISPLAY_TYPE_GENERAL_ONLY,
	NOTE_DISPLAY_PROP_CREATED_DATE,
	NOTE_DISPLAY_PROP_APPLIES_TO,
	NOTE_DISPLAY_PROP_DOMAIN_LABEL,
	NOTE_DISPLAY_PROP_REPLIES,
	NOTE_DISPLAY_PROP_AUTHOR,
	NOTE_DISPLAY_PROP_DESCENDANTS,
	REPEAT_BY_CAT_OR_RANGE_RESTRICTION_NONE,
	REPEAT_BY_CAT_OR_RANGE_RESTRICTION_DEFAULT,
	REPEAT_BY_CAT_OR_RANGE_RESTRICTION_CUSTOM,
	DEFAULT_GROUP_INDEX_KEY,
	DATASET_REPORT_TYPE,
	TODAYS_PSEUDO_PERIOD_ID,
	DEFAULT_LABEL_ELLIPSIS_THRESHOLD,
	ELLIPSIS,
	formatForBlankLabel
}

function formatForBlankLabel(data = {}) {
	if (!data.style) {
		data.style = {}
	}
	data.html = i18n.get('common.blank')
	data.style['blank-value'] = true
	return data
}

function truncateLongString(data, maxLength = reportConstants.DEFAULT_LABEL_ELLIPSIS_THRESHOLD) {
	if (!data || data.length < maxLength) { return data }
	return data.substring(0, maxLength) + reportConstants.ELLIPSIS
}

/**
 * @param {String} value an html string of the value
 * @param {String} label the label of what the value represents (i.e. dataset field name)
 * @param {Boolean} [opts.escapeLabel=true] whether we need to escape the label
 * @param {Integer} [opts.maxLabelLength] the max length of the label before
 * truncating
 * @param {Boolean} [opts.useEmptyLabel] whether to use an empty label or just
 * return the value
 */
function labeledValue(value, label = null, opts = {escapeLabel: true}) {
	if (_.isNil(label) || _.isEmpty(label)) {
		if (opts.useEmptyLabel) {
			label += ''
		} else {
			return value
		}
	}
	if (!_.isNil(opts.maxLabelLength) && opts.maxLabelLength > 0) {
		label = truncateLongString(label, opts.maxLabelLength)
	}
	if (opts.escapeLabel) {
		label = _.escape(label)
	}

	const updatedEl = $(value).addClass('labeled-value-value')
	// If there is no value, prevent "undefined" from displaying in the browser.
	// Can't set to null, or else the browser will display "null".
	value = updatedEl[0] ? updatedEl[0].outerHTML : ''

	// wrap label so it can be truncated if needed
	label = `<span class="labeled-value-label">${label}</span>`

	return label + value
}

export default reportConstants
export { formatForBlankLabel, truncateLongString, labeledValue }
reportConstants.__filename__ = 'reports/report-constants.js'
